import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

/**
 * SellerLicenseRoute — wraps any /supplier/* route to enforce an
 * active license. If the seller has not paid (or the license has
 * lapsed), they are redirected to `/supplier/license`.
 */
export function SellerLicenseRoute({ children }) {
  const { user, api } = useAuth();
  const [state, setState] = useState(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    let cancel = false;
    (async () => {
      if (!user) { setChecked(true); return; }
      if ((user.account_type || user.role) !== "seller") { setChecked(true); return; }
      try {
        const r = await api.get("/seller/license/status");
        if (!cancel) setState(r.data);
      } catch { if (!cancel) setState({ active: false }); }
      if (!cancel) setChecked(true);
    })();
    return () => { cancel = true; };
  }, [api, user]);

  if (user === null) return null;
  if (!user) return <Navigate to="/login" replace />;
  if ((user.account_type || user.role) !== "seller") return <Navigate to="/account" replace />;
  if (!checked) {
    return (
      <div className="min-h-screen bg-[#050506] text-[#F5F5F0] flex items-center justify-center">
        <Loader2 size={20} className="animate-spin text-[#D8B23E]"/>
      </div>
    );
  }
  if (!state?.active) return <Navigate to="/supplier/license" replace />;
  return children;
}
